import { API } from "../../utils/_HttpUtils";
import { user_routes as routes } from "../../constants/api-routes";

const addCustomerFarabi = (otp, fund_id = null) =>
    new API().send("POST", routes.addCustomerFarabi, {
        otp,
        ...(fund_id && { fund_id }),
    });

export { addCustomerFarabi };
